import React from "react";

export default function Material({ handleFilterClick, productMaterial }) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productMaterial = sortObject(productMaterial);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("material") &&
    plpFacetLabel.material != ""
      ? plpFacetLabel.material
      : "Material";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productMaterial).map((material, i) => {
          if (material && productMaterial[material] > 0) {
            return (
              <div>
                <span
                  id={`material-${i}`}
                  key={i}
                  data-value={`${material.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("material", e.target.dataset.value)
                  }>
                  {" "}
                  {material} {` (${productMaterial[material]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
